function includes(list, value) {
  return list.some(item => item === value);
}

export { includes };
